import React from 'react';

import { useSelector } from 'react-redux';
import { selectLogLevel } from '../../reducers/UxReducers';

export function useLogLevels() {
  const globalLogLevel = useSelector(selectLogLevel);

  // Sync Redux log level to window.moo for logger access
  React.useEffect(() => {
    if (window.moo) {
      (window.moo as any).logLevel = globalLogLevel;
    }
  }, [globalLogLevel]);
}
